var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.1,
    height: 15.512,
    viewBox: "0 0 15.1 15.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account",
    d: "M138.985,69.152a4.748,4.748,0,0,1,4.592-1.214l5.824-5.824a.4.4,0,0,1,.251-.119l2.613-.2h0a.4.4,0,0,1,.422.44l-.361,3.58a.4.4,0,0,1-.391.356h-1.293v1.293a.4.4,0,0,1-.4.4h-1.293v1.293a.4.4,0,0,1-.114.281l-1.882,1.882a4.766,4.766,0,1,1-7.97-2.164Zm.563.563a3.981,3.981,0,1,0,6.6,1.584h0a.4.4,0,0,1,.1-.4l1.909-1.909V67.458h0a.4.4,0,0,1,.4-.4h1.293V65.769a.4.4,0,0,1,.4-.4h1.337l.273-2.745-1.988.15L144,68.646h0a.4.4,0,0,1-.4.1,3.976,3.976,0,0,0-4.042.972Zm.7,2.674a1.592,1.592,0,1,1,0,2.252A1.6,1.6,0,0,1,140.252,72.389Zm.563.563a.8.8,0,1,0,1.126,0A.79.79,0,0,0,140.815,72.952Z",
    transform: "translate(-137.589 -61.792)",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNew);
export default __webpack_public_path__ + "static/media/accountNew.0201568445daf428469a9f7c7167b966.svg";
export { ForwardRef as ReactComponent };